// extracted by mini-css-extract-plugin
export default {"card":"ZtImg_card__7s8fm","card_img":"ZtImg_card_img__y7cRq"};